module.exports = __webpack_public_path__ + "media/images/help/faq-search-filter-ccad751105f0f92bd899b95eebe6af72.jpg";